<template>
    <a-layout-sider
        theme="dark"
        data-cy="layout-sidebar"
        :collapsible="isProdOrPreprod ? null : true"
        :collapsed="isProdOrPreprod ? false : isCollapsed"
        class="layout-sidebar"
        :class="{ 'layout-prod-sidebar': isProdOrPreprod, 'show': isMenuShowing }"
        @collapse="isCollapsed = $event"
    >
        <prod-menu v-if="isProdOrPreprod" :current-key="currentKey" />

        <native-menu v-else :current-key="currentKey" />
    </a-layout-sider>
</template>

<script>
import { mapGetters } from 'vuex';
import NativeMenu from './Menu';
import ProdMenu from './ProdMenu'; // @TMP?

export default {
    components: {
        ProdMenu,
        NativeMenu
    },

    data() {
        return {
            isCollapsed: true,
            windowWidth: window.innerWidth
        };
    },

    computed: {
        ...mapGetters({
            isProdOrPreprod: 'environments/isProdOrPreprod',
            isMenuShowing: 'menuShowing',
            isMobile: 'isMobile/isMobile',
            globalLoading: 'loading',

        }),

        currentKey() {
            const [, path] = this.$route.path.split('/');

            return `/${path}`;
        },

        isWidthMobile() {
            return this.windowWidth < 835;
        }
    },

    mounted() {
        window.addEventListener('resize', this.handleResize);
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },

    methods: {
        handleResize() {
            this.windowWidth = window.innerWidth;
        }
    }
};
</script>
